const parseFullNameFromEmail = (email: string) => {
    const index = email.indexOf("@");
    const prefix = email.substring(0, index);
    const fullName = prefix.split('.');
    return fullName.join(" ").toUpperCase();
}

export {parseFullNameFromEmail}
